import { useProjectContext } from "@contexts/projects";
import { isPending, PENDING_BANNER_TEXT, PENDING_BANNER_TITLE } from "./summary";

// Banner no topo do painel da obra (padrão `alert alert-info`: h3.info-title + p) quando a lista
// de títulos anulados mudou e nenhum processamento financeiro ou completo da obra a aplicou
// ainda. Some sozinho quando `titleAnnulments.pending` volta a ser nulo.
const PendingBanner = () => {
  const { activeProject } = useProjectContext();
  if (!isPending(activeProject?.titleAnnulments)) return null;
  return (
    <div className="alert alert-info margin-top-24" role="status" data-testid="title-annulments-banner">
      <h3 className="info-title">{PENDING_BANNER_TITLE}</h3>
      <p>{`${PENDING_BANNER_TEXT}. Os valores de pago e a pagar só refletem a lista depois do próximo processamento financeiro ou completo desta obra.`}</p>
    </div>
  );
};

export default PendingBanner;
